import { useQueryClient, useInfiniteQuery } from 'react-query';
import requester from 'utils/requester';
import api from 'config/api';
import Platform from 'platform';
import { isEmpty } from 'lodash';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import { getAuthorizedEndpointUrl } from 'helpers/urlhelper';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const KEY = 'USE_VOD_SERCH';

const PER_PAGE = 20;

const apiCall = async ({ isLoggedIn, query, page = 1 }) => {
  const params = {
    f_deviceType: Platform.getDeviceType(),
    page,
    size: PER_PAGE,
    ...query,
  };

  if (!isLoggedIn) params['f_tenants.id'] = 1;

  const data = await requester({
    method: 'get',
    url: `${api.host}${getAuthorizedEndpointUrl(api.endpoints.searchVodPublic, isLoggedIn)}`,
    appendParams: false,
    params,
  });

  return data;
};

const useVodSearch = (query = {}, options) => {
  const queryClient = useQueryClient();
  const isLoggedIn = useSelector(getIsLoggedInSelector);

  useEffect(() => {
    if (!options?.enabled) {
      queryClient.resetQueries([KEY, isLoggedIn, query]);
    }
  }, [isLoggedIn, options?.enabled, query, queryClient]);

  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useInfiniteQuery(
    [KEY, isLoggedIn, query],
    ({ pageParam }) => apiCall({ isLoggedIn, query, page: pageParam?.page }),
    {
      getNextPageParam: (lastPage, pages) => {
        if (!isEmpty(lastPage)) return { page: pages.length + 1 };
      },
      select(data) {
        return data.pages.flat();
      },
      cacheTime: 60 * 1000,
      ...options,
    },
  );

  return { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage };
};

export default useVodSearch;
